'use client';

import { c as _c } from "react/compiler-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { useTRPC } from '@/app/api/trpc/config';
import { Button } from '@/frontend/design-system/actions/Button';
import { showErrorToastWithContactFormLink } from '@/frontend/design-system/feedback/Toaster/ToasterError';
import { ErrorMessage, Field } from '@/frontend/design-system/forms/Fieldset';
import { Input } from '@/frontend/design-system/forms/Input';
import { type NotificationAboutCourseSchema, notificationAboutCourseSchema } from '../schema';
export function NotificationAboutCourseForm(t0) {
  const $ = _c(23);
  const {
    courseCategory
  } = t0;
  const trpc = useTRPC();
  let t1;
  if ($[0] !== trpc.notifications.sendEmails) {
    t1 = trpc.notifications.sendEmails.mutationOptions();
    $[0] = trpc.notifications.sendEmails;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sendEmailMutation = useMutation(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      resolver: zodResolver(notificationAboutCourseSchema)
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    register,
    handleSubmit,
    formState: t3,
    reset
  } = useForm(t2);
  const {
    errors
  } = t3;
  let t4;
  if ($[3] !== courseCategory || $[4] !== reset || $[5] !== sendEmailMutation) {
    t4 = async data => {
      try {
        const message = `Użytkownik ${data.email} chce otrzymać powiadomienie o ponownym otwarciu zapisów na kurs: ${courseCategory}`;
        await sendEmailMutation.mutateAsync({
          emailData: {
            subject: `Powiadomienie o kursie: ${courseCategory}`,
            htmlContent: message
          }
        });
        toast.success("Uda\u0142o si\u0119!", {
          description: "Otrzymasz powiadomienie email, gdy zapisy na kurs zostan\u0105 ponownie otwarte."
        });
        reset();
      } catch {
        showErrorToastWithContactFormLink();
      }
    };
    $[3] = courseCategory;
    $[4] = reset;
    $[5] = sendEmailMutation;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const onSubmitNotification = t4;
  let t5;
  if ($[7] !== handleSubmit || $[8] !== onSubmitNotification) {
    t5 = handleSubmit(onSubmitNotification);
    $[7] = handleSubmit;
    $[8] = onSubmitNotification;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== register) {
    t6 = register("email");
    $[10] = register;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Input {...t6} placeholder="Email" type="email" />;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== errors.email) {
    t8 = errors.email?.message && <ErrorMessage>{errors.email.message}</ErrorMessage>;
    $[14] = errors.email;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <Field>{t7}{t8}</Field>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Button marketing={true} type="submit" className="h-full w-full sm:w-fit">Otrzymaj powiadomienie</Button>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t5 || $[21] !== t9) {
    t11 = <form onSubmit={t5} className="flex flex-col gap-4 sm:flex-row">{t9}{t10}</form>;
    $[20] = t5;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}